<app-block-ui [loading]="loading">
  <ng-container>
    <p>Učitavanje</p>
  </ng-container>
</app-block-ui>
<form [formGroup]="updateProductForm" (ngSubmit)="onUpdateProduct()">
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button class="main-btn" type="submit">
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <div class="grid">
      <div class="col-4">
        <h3 class="card-title">Izmeni proizvod</h3>
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <h3 class="card-title">Statistika</h3>
      </div>
    </div>

    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Šarža broj</label>
            <input type="text" formControlName="batch" pInputText />
          </div>
          <div class="field">
            <label>Šifra proizvoda</label>
            <input type="text" formControlName="label" pInputText />
          </div>
          <div class="field">
            <label>Naziv proizvoda</label>
            <input type="text" formControlName="name" pInputText />
          </div>
          <div class="field">
            <label>Tip</label>
            <p-dropdown
              [options]="productTypes"
              optionLabel="name"
              formControlName="product_type_id"
              optionValue="id"
              placeholder="Izaberi tip"
            ></p-dropdown>
          </div>
          <!-- <div class="field w-100">
            <label>Prosečno vreme</label>
            <input
              type="text"
              class="w-100"
              formControlName="total_estimated_time"
              pInputText
            />
          </div> -->
        </div>

        <div class="col-4">
          <div class="field">
            <label>Napomena</label>
            <textarea
              rows="13"
              cols="30"
              pInputTextarea
              autoResize="autoResize"
              formControlName="description"
            ></textarea>
          </div>
        </div>

        <div class="col-4 flex flex-column" *ngIf="stats">
          <ng-container *ngIf="stats.product_stats.avg; else elseTemplate">
            <div class="flex flex-column justify-content-center mb-3">
              <span class="flex align-items-center">
                <i class="pi pi-caret-down mr-1"></i> Minimalno vreme</span
              >
              <h1>{{ stats?.product_stats.min }}</h1>
            </div>
            <div class="flex flex-column justify-content-center mb-3">
              <span class="flex align-items-center"
                ><i class="pi pi-caret-up mr-1"></i> Maksimalno vreme</span
              >
              <h1>{{ stats?.product_stats.max }}</h1>
            </div>
            <div class="flex flex-column justify-content-center">
              <span class="flex align-items-center">
                <i class="pi pi-chart-bar mr-1"></i> Prosečno vreme</span
              >
              <h1>{{ stats?.product_stats.avg }}</h1>
            </div>
          </ng-container>
          <ng-template #elseTemplate>
            <p>Ovaj proizvod još uvek nema svoju statistiku.</p>
          </ng-template>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <h3 class="card-title">Redosled operacija</h3>
        </div>

        <div class="col-12">
          <ul
            dragula="OPERATIONS"
            formArrayName="operations"
            [(dragulaModel)]="getOperationsControls.controls"
          >
            <li
              *ngFor="
                let operations of getOperationsControls.controls;
                let formGroupIndex = index
              "
              [formGroupName]="formGroupIndex"
            >
              <p-panel
                [toggleable]="true"
                styleClass="mb-3"
                collapsed="true"
                collapseIcon="pi pi-chevron-right"
                expandIcon="pi pi-chevron-down"
              >
                <p-header class="w-100 ml-0 p-2 panel-header">
                  <section
                    class="flex align-items-center justify-content-between"
                  >
                    <section class="flex align-items-center flex-wrap">
                      <div class="drag-handle mr-3">
                        <i class="pi pi-list"></i>
                        <span class="handle"></span>
                      </div>
                      <h3 class="mr-3">{{ formGroupIndex + 1 }}.</h3>
                      <div class="field mr-3 mb-0">
                        <label>Naziv operacije</label>
                        <p-dropdown
                          #operationId
                          [options]="allOperations"
                          (onChange)="onChangeOperation($event, formGroupIndex)"
                          optionLabel="name"
                          placeholder="Izaberi operaciju"
                          formControlName="operation_id"
                          optionValue="id"
                        ></p-dropdown>
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Pripremno vreme</label>
                        <input
                          type="text"
                          formControlName="prep_time"
                          (input)="
                            updateOperationFields(operations, ['prep_time'])
                          "
                          pInputText
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme operacije</label>
                        <input
                          type="text"
                          formControlName="operation_time"
                          (input)="
                            updateOperationFields(operations, [
                              'operation_time'
                            ])
                          "
                          pInputText
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme do sl. operacije</label>
                        <input
                          type="text"
                          formControlName="next_op_time"
                          (input)="
                            updateOperationFields(operations, ['next_op_time'])
                          "
                          pInputText
                        />
                      </div>
                    </section>

                    <button
                      class="second-btn small-btn"
                      type="button"
                      pTooltip="Ukloni"
                      tooltipPosition="top"
                      (click)="removeOperation(formGroupIndex)"
                    >
                      <i class="pi pi-trash"></i>
                    </button>
                  </section>
                </p-header>

                <section
                  *ngIf="
                    getSuboperationsControls(formGroupIndex).controls.length
                  "
                >
                  <ul
                    [dragula]="'SUBOPERATIONS' + formGroupIndex"
                    formArrayName="suboperations"
                    [(dragulaModel)]="
                      getSuboperationsControls(formGroupIndex).controls
                    "
                  >
                    <li
                      *ngFor="
                        let suboperations of getSuboperationsControls(
                          formGroupIndex
                        ).controls;
                        let i = index
                      "
                      [formGroupName]="i"
                    >
                      <section
                        class="flex align-items-center justify-content-between m-3 ml-3"
                      >
                        <section class="flex align-items-center">
                          <h3 class="mr-3">{{ i + 1 }}.</h3>
                          <div class="field mr-3">
                            <label>Naziv podoperacije</label>
                            <p-dropdown
                              [options]="findOperation(operationId.value)"
                              (onChange)="
                                onChangeSuboperation(
                                  $event,
                                  operationId.value,
                                  formGroupIndex,
                                  i,
                                  operations,
                                  [
                                    'prep_time',
                                    'operation_time',
                                    'next_op_time'
                                  ]
                                )
                              "
                              optionLabel="name"
                              placeholder="Izaberi podoperaciju"
                              formControlName="suboperation_id"
                              optionValue="id"
                            ></p-dropdown>
                          </div>
                          <div class="field mr-3">
                            <label>Pripremno vreme</label>
                            <input
                              type="text"
                              formControlName="prep_time"
                              pInputText
                              (input)="
                                updateOperationFields(operations, ['prep_time'])
                              "
                            />
                          </div>
                          <div class="field mr-3">
                            <label>Vreme operacije</label>
                            <input
                              type="text"
                              formControlName="operation_time"
                              (input)="
                                updateOperationFields(operations, [
                                  'operation_time'
                                ])
                              "
                              pInputText
                            />
                          </div>
                          <div class="field mr-3">
                            <label>Vreme do sl. operacije</label>
                            <input
                              type="text"
                              formControlName="next_op_time"
                              (input)="
                                updateOperationFields(operations, [
                                  'next_op_time'
                                ])
                              "
                              pInputText
                            />
                          </div>
                        </section>

                        <button
                          class="second-btn small-btn"
                          type="button"
                          pTooltip="Ukloni"
                          tooltipPosition="top"
                          (click)="removeSuboperation(i, formGroupIndex)"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </section>
                    </li>
                  </ul>
                </section>

                <button
                  class="second-btn ml-6"
                  type="button"
                  (click)="addSuboperation(formGroupIndex)"
                >
                  Dodaj podoperaciju
                </button>
              </p-panel>
            </li>
          </ul>
          <button
            class="second-btn mt-1"
            type="button"
            (click)="addOperation()"
          >
            Dodaj operaciju
          </button>
        </div>

        <!-- ADD file  --------------------------------------------->
        <div class="col-12 flex align-items-center file-upload-wrapper mt-2">
          <h3 class="card-title mt-0 mr-3">Datoteke</h3>
          <p-fileUpload
            (onSelect)="onFileUpload($event)"
            mode="basic"
          ></p-fileUpload>
        </div>
        <div class="col-12">
          <p-table
            *ngIf="productForEdit"
            [value]="productForEdit.tehnical_documentations"
            dataKey="id"
            styleClass="p-datatable-customers p-datatable-gridlines "
          >
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <div class="flex justify-content-between align-items-center">
                    Naziv datoteke
                  </div>
                </th>
                <th style="width: 8rem">
                  <div class="flex justify-content-between align-items-center">
                    Akcija
                  </div>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-document>
              <tr>
                <td>
                  <span class="image-text">{{ document?.name }}</span>
                </td>
                <td class="text-center">
                  <a
                    class="second-btn small-btn mr-2"
                    pTooltip="Otvori"
                    tooltipPosition="top"
                    [href]="document.path"
                    target="_blank"
                  >
                    <i class="pi pi-eye"></i>
                  </a>

                  <button
                    class="second-btn small-btn"
                    type="button"
                    pTooltip="Izbriši"
                    tooltipPosition="top"
                    (click)="onDeleteDocument($event, document)"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3">Ni jedna datoteka nije pronađena.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      <div class="grid" *ngIf="stats">
        <div class="col-12">
          <h3 class="card-title">Statistika radnih naloga</h3>
        </div>

        <div class="col-12">
          <p-tabView>
            <p-tabPanel header="Po unosima vremena">
              <!-- * TABELA -->
              <p-table
                #dt1
                [value]="stats.nips"
                dataKey="id"
                [rows]="50"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                styleClass="p-datatable-customers p-datatable-gridlines "
                [paginator]="false"
                currentPageReportTemplate="Prikaz od {first}. do {last}. operacije od ukupno {totalRecords}"
                [globalFilterFields]="['label', 'name']"
              >
                <ng-template pTemplate="caption"> </ng-template>

                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 4.5rem"></th>
                    <th>
                      <div
                        class="flex justify-content-between align-items-center"
                      >
                        Šarža broj
                      </div>
                    </th>
                    <th>Broj zahteva</th>
                    <th>Ukupno vreme</th>
                    <th>Partner</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-nip let-expanded="expanded">
                  <tr>
                    <td>
                      <button
                        type="button"
                        pButton
                        [pRowToggler]="nip"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="
                          expanded
                            ? 'pi pi-chevron-down'
                            : 'pi pi-chevron-right'
                        "
                      ></button>
                    </td>
                    <td>
                      {{ nip.batch }}
                    </td>
                    <td>
                      {{ nip.request_nr }}
                    </td>
                    <td>
                      {{ nip.total_time }}
                    </td>
                    <td>
                      {{ nip.partner.company }}
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="rowexpansion" let-nip>
                  <tr>
                    <td colspan="5">
                      <div class="pt-0 mb-4 subtable">
                        <p-table [value]="nip.time_trackers" dataKey="id">
                          <ng-template pTemplate="header">
                            <tr>
                              <th>Naziv operacije</th>
                              <th>Količina spremno</th>
                              <th>Ukupno vreme</th>
                              <th>Start</th>
                              <th>Stop</th>
                              <th>Dokumentacija</th>
                              <th>Škart</th>
                              <th>Zastoj</th>
                              <th>Komentar</th>
                              <th>Radnik</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-timer_tracker>
                            <tr>
                              <td>{{ timer_tracker.operation_label }}</td>
                              <td>{{ timer_tracker.produced_amount }}</td>
                              <td>{{ timer_tracker.total_time }}</td>
                              <td>
                                {{
                                  timer_tracker.start
                                    | date : "dd.MM.yyyy HH:mm:ss"
                                }}
                              </td>
                              <td>
                                {{
                                  timer_tracker.end
                                    | date : "dd.MM.yyyy HH:mm:ss"
                                }}
                              </td>
                              <td>
                                <ng-container
                                  *ngIf="!timer_tracker.documentation_correct"
                                  >Zahteva izmene</ng-container
                                >
                              </td>
                              <td>
                                <span
                                  class="alert-chip"
                                  *ngIf="timer_tracker.scrap_amount"
                                >
                                  {{ timer_tracker.scrap_amount }}</span
                                >
                                <span
                                  class="reasons-span"
                                  *ngFor="
                                    let reason of timer_tracker.scrap_reasons
                                  "
                                >
                                  {{ reason | reasons }}
                                </span>
                              </td>
                              <td>
                                <span
                                  class="warning-chip"
                                  *ngIf="timer_tracker.delay_duration"
                                >
                                  {{ timer_tracker.delay_duration }}</span
                                >
                                <span
                                  class="reasons-span"
                                  *ngFor="
                                    let reason of timer_tracker.delay_reasons
                                  "
                                >
                                  {{ reason | reasons }}</span
                                >
                              </td>
                              <td>{{ timer_tracker.comment }}</td>
                              <td>
                                {{
                                  timer_tracker.user.fname +
                                    " " +
                                    timer_tracker.user.lname
                                }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">
                                Ovaj proizvod nema statistiku radnih naloga.
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4">
                      Ovaj proizvod nema statistiku radnih naloga.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <p-paginator
                [first]="1"
                [rows]="stats.per_page"
                [showJumpToPageDropdown]="true"
                [showPageLinks]="true"
                [totalRecords]="stats.total"
                (onPageChange)="onActivitesPageChange($event)"
                [showPageLinks]="false"
              ></p-paginator>
              <!-- * TABELA -->
            </p-tabPanel>
            <p-tabPanel header="Po operacijama">
              <!-- * TABELA -->
              <p-table
                #dt1
                [value]="stats.nips"
                dataKey="id"
                [rows]="50"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                styleClass="p-datatable-customers p-datatable-gridlines "
                [paginator]="false"
                currentPageReportTemplate="Prikaz od {first}. do {last}. operacije od ukupno {totalRecords}"
                [globalFilterFields]="['label', 'name']"
              >
                <ng-template pTemplate="caption"> </ng-template>

                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 4.5rem"></th>
                    <th>
                      <div
                        class="flex justify-content-center align-items-center"
                      >
                        Šarža broj
                      </div>
                    </th>
                    <th>Broj zahteva</th>
                    <th>Ukupno vreme</th>
                    <th>Partner</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-nip let-expanded="expanded">
                  <tr>
                    <td>
                      <button
                        type="button"
                        pButton
                        [pRowToggler]="nip"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="
                          expanded
                            ? 'pi pi-chevron-down'
                            : 'pi pi-chevron-right'
                        "
                      ></button>
                    </td>
                    <td>
                      {{ nip.batch }}
                    </td>
                    <td>
                      {{ nip.request_nr }}
                    </td>
                    <td>
                      {{ nip.total_time }}
                    </td>
                    <td>
                      {{ nip.partner.company }}
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="rowexpansion" let-nip>
                  <tr>
                    <td colspan="5">
                      <div class="pt-0 mb-4 subtable">
                        <p-table [value]="nip.operation_times" dataKey="id">
                          <ng-template pTemplate="header">
                            <tr>
                              <th>Naziv operacije</th>
                              <th>Ukupno vreme</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-timer_tracker>
                            <tr>
                              <td>{{ timer_tracker.operation_label }}</td>
                              <td>{{ timer_tracker.total_time }}</td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">
                                Ovaj proizvod nema statistiku radnih naloga.
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4">
                      Ovaj proizvod nema statistiku radnih naloga.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <p-paginator
                [first]="1"
                [rows]="stats.per_page"
                [showJumpToPageDropdown]="true"
                [showPageLinks]="true"
                [totalRecords]="stats.total"
                (onPageChange)="onActivitesPageChange($event)"
                [showPageLinks]="false"
              ></p-paginator>
              <!-- * TABELA -->
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </div>
</form>
